module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Settings")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "m-4 text-center"
  }, [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "bg-color-1 lightest text-right p-4"
  }, [(_vm.getProductEditPriceData.audienceType) ? _c('div', {
    staticClass: "text-uppercase"
  }, [_vm._v("\n                    Total per " + _vm._s(_vm.audienceIdToName(_vm.getProductEditPriceData.audienceType)) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "totalValue"
  }, [_vm._v("\n                    " + _vm._s(_vm.totalPVP) + " €\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "p-5"
  }, [_c('split-price-editor')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center justify-content-end",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-70aca0d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70aca0d4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ProductEditPrice.vue
// module id = 990
// module chunks = 0